export default __webpack_public_path__ + "static/media/uv44_en_alph_a2.277d6f23.mp3";